/**
 * Normaliza um valor de FEATURE_FLAGS que deveria ser boolean, mas pode chegar
 * do CMS como string ("true"/"false") por erro de configuração.
 */
export const isFlagEnabled = (value) => value === true || value === 'true';
